module.exports = Number.isNaN || function isNaN(a) {
	return a !== a;
};



//////////////////
// WEBPACK FOOTER
// ../node_modules/es-abstract/helpers/isNaN.js
// module id = 787
// module chunks = 0